import { render, staticRenderFns } from "./BizLocEmissionByScope.vue?vue&type=template&id=22556854"
import script from "./BizLocEmissionByScope.vue?vue&type=script&lang=js"
export * from "./BizLocEmissionByScope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports